export enum FilterType {
  Lowpass = 'lowpass',
  LP4 = 'order 4 lowpass',
  LP8 = 'order 8 lowpass',
  LP16 = 'order 16 lowpass',
  Highpass = 'highpass',
  HP4 = 'order 4 highpass',
  HP8 = 'order 8 highpass',
  HP16 = 'order 16 highpass',
  Bandpass = 'bandpass',
  BP4 = 'order 4 bandpass',
  BP8 = 'order 8 bandpass',
  BP16 = 'order 16 bandpass',
  DynaBP_50 = 'dynamic bandpass (50 Hz)',
  DynaBP_100 = 'dynamic bandpass (100 Hz)',
  DynaBP_200 = 'dynamic bandpass (200 Hz)',
  DynaBP_400 = 'dynamic bandpass (400 Hz)',
  DynaBP_800 = 'dynamic bandpass (800 Hz)',
  Lowshelf = 'lowshelf',
  Highshelf = 'highshelf',
  Peaking = 'peaking',
  Notch = 'notch',
  Allpass = 'allpass',
}
